import { animate, state, style, transition, trigger } from '@angular/animations';
import { Location } from '@angular/common';
import { Component, forwardRef, Inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng';
import { LoggerService } from '../../services/logger.service';
import { MenuService } from '../../services/menu.service';
import { MenuPinService } from '../../services/menu-pin.service';
import { TaggedLogger } from '../../services/taggedLogger';
import { AppComponent } from './app.component';

@Component({
  selector: '[app-submenu]',
  templateUrl: './app-sub-menu.component.html',
  animations: [
    trigger('children', [
      state(
        'hidden',
        style({
          height: '0px',
        }),
      ),
      state(
        'visible',
        style({
          height: '*',
        }),
      ),
      transition('visible => hidden', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
      transition('hidden => visible', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
    ]),
  ],
})
export class AppSubMenu {
  private logger: TaggedLogger;

  @Input() item: MenuItem;

  @Input() root: boolean;

  @Input() visible: boolean;

  _reset: boolean;

  activeIndex: number;

  constructor(
    @Inject(forwardRef(() => AppComponent)) public app: AppComponent,
    public router: Router,
    public location: Location,
    public menuService: MenuService,
    public menuPinService: MenuPinService,
    loggerService: LoggerService,
  ) {
    this.logger = loggerService.taggedLogger('SubMenu');
  }

  itemClick(event: Event, item: MenuItem, index: number) {
    this.logger.debug('Clicked', item.label);
    this.menuService.setselectedMenu(item.label);
    //avoid processing disabled items
    if (item.disabled) {
      event.preventDefault();
      return true;
    }

    //activate current item and deactivate active sibling if any
    this.activeIndex = this.activeIndex === index ? null : index;

    //execute command
    if (item.command) {
      item.command({
        originalEvent: event,
        item: item,
      });
    }

    //prevent hash change
    if (item.items || (!item.url && !item.routerLink)) {
      event.preventDefault();
    }

    //hide menu
    if (!item.items) {
      if (this.app.isHorizontal()) this.app.resetMenu = true;
      else this.app.resetMenu = false;

      this.app.overlayMenuActive = false;
      this.app.staticMenuMobileActive = false;
    }
  }

  private driverPortal() {
    window.open('https://www.google.com', '_blank');
  }

  isActive(index: number): boolean {
    return this.activeIndex === index;
  }

  @Input() get reset(): boolean {
    return this._reset;
  }

  set reset(val: boolean) {
    this._reset = val;

    if (this._reset && this.app.isHorizontal()) {
      this.activeIndex = null;
    }
  }
}
